import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { FILE_DOWNLOAD_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
import axios from "axios";
import { URLS } from "../ApiUrls";

export default class FileDownloadRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  url = FILE_DOWNLOAD_URL;

  body = {};

  constructor(fileId) {
    super();
    this.fileId = fileId;
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => getCurrentUserParameters(this.url.replace("%1", this.fileId));

  getBody = () => this.body;

  // Override getData to handle binary response
  getData = () => {
    const accessToken = sessionStorage.getItem("token");
    const fullUrl = `${this.getUrl()}`;

    return axios({
      method: this.getMethod(),
      url: fullUrl,
      responseType: "blob", // Important: This tells axios to expect binary data
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (!response) {
          throw new Error("response undefined");
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}
